namespace GeniuzPOS.SalePromoCamp {
    export enum PromoCustFg {
        PromoCustFg = 0,
        PromoCustFg1 = 1,
        PromoCustFg2 = 2,
        PromoCustFg3 = 3
    }
    Serenity.Decorators.registerEnumType(PromoCustFg, 'GeniuzPOS.SalePromoCamp.PromoCustFg');
}
